module.exports = __webpack_public_path__ + "cardiometabolic-diagram.cccc13e218eaefd0b3c8402889b02950.png";